(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    '<span translate="global.pagination.showing">Showing </span> ' +
                    '{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    '<span translate="global.pagination.of">of </span> ' +
                    '{{$ctrl.queryCount}} <span translate="global.pagination.items">items </span>' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('superChannelApp')
        .component('jhiItemCount', jhiItemCount);
})();
